import React, { useState } from "react";
import "./About.css"; // Import your CSS for styling

const About = () => {
  const [showMission, setShowMission] = useState(null);

  const handleMissionClick = (index) => {
    setShowMission(index === showMission ? null : index);
  };

  const missionData = [
    {
      title: "Mission 1",
      statement: "Our mission is to provide high-quality products and excellent customer service to our valued customers. We aim to deliver the best products in the industry and continuously improve our services to meet customer expectations.",
    },
    {
      title: "Mission 2",
      statement: "We are committed to environmental responsibility and sustainability. Our mission is to protect and preserve the environment by reducing our carbon footprint, conserving natural resources, and promoting sustainable practices in all aspects of our operations.",
    },
    {
      title: "Mission 3",
      statement: "Our vision is to create a positive impact on society through innovation, research, and development. We strive to make a meaningful difference by investing in groundbreaking technologies and delivering cutting-edge solutions for a better world.",
    },
  ];

  return (
    <div className="about-container">
      <h1 className="about-header">About Us</h1>
      <div className="mission-cards">
        {missionData.map((mission, index) => (
          <div
            key={index}
            className={`mission-card ${showMission === index ? "active" : ""}`}
            onClick={() => handleMissionClick(index)}
          >
            <div className="card-header">{mission.title}</div>
            <div className="card-body">
              {showMission === index ? mission.statement : "Click to reveal mission statement"}
            </div>
          </div>
        ))}
      </div>
      <p className="creators-paragraph">
      Hello, these are the creators of BuildMeUp. We are a group of three freshmen, Rahul Vuggumudi, Akshar Koul, and Nihal Neerukonda, studying Computer Science at the University of Texas at Austin. We are passionate about creating innovative solutions to make a positive impact on society.
      </p>
      <p className="creators-paragraph2">
      "Our vision is to improve the lives of everyone in construction." - Procore
      </p>
    </div>
  );
};

export default About;
